import React from 'react';

interface IProps {
  stepsAmount: number;
  currentStep: number;
  stepContainerCSS: string;
  stepCSS: string;
  passStepAnimation: string;
  mainContainerCSS: string;
}
const LinedStepper = ({
  stepsAmount, currentStep, stepContainerCSS, stepCSS, passStepAnimation, mainContainerCSS,
}: IProps) => {
  const getStepsComponents = () => {
    if (stepsAmount && currentStep) {
      const stepsArray = [];
      for (let i = 1; i <= stepsAmount; i++) {
        stepsArray.push(
          <div data-testid={`testId${i}`} key={`step${i}`} className={stepContainerCSS}>
            <div className={i < currentStep ? stepCSS : i === currentStep ? `${stepCSS} ${passStepAnimation}` : ''} />
          </div>,
        );
      }
      return stepsArray;
    }
    return null;
  };

  return (
    <div data-testid='LinedStepperContainer' className={mainContainerCSS}>
      {getStepsComponents()}
    </div>
  );
};

export default LinedStepper;
